'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { AppBar, Drawer, IconButton } from '@/primitives';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { NAV_HEIGHT } from '@/configs/layout';
import { PUBLIC_ROUTES } from '@/configs/routes';
import { slate } from '@/lib/colours';
import Navigation from './Navigation';

export default function MobileToolbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: '12px',
          borderBottom: 'unset',
          height: `${NAV_HEIGHT}px`,
          backgroundColor: 'white',

          '@media print': {
            display: 'none',
          },
        }}
      >
        <Link href={PUBLIC_ROUTES.HOME} style={{ display: 'flex' }}>
          <Image
            alt="BreedLOGIC Logo"
            height={37}
            width={176}
            src="/breedlogic-logo.svg"
          />
        </Link>
        <IconButton onClick={() => setDrawerOpen(true)}>
          <MenuIcon sx={{ color: slate[500], fontSize: '32px' }} />
        </IconButton>
      </AppBar>
      <Drawer
        anchor="left"
        open={drawerOpen}
        sx={{
          flexShrink: 0,

          '& .MuiDrawer-paper': {
            p: 0,
            width: '90%',
            maxWidth: '360px',
            boxSizing: 'border-box',
            borderRadius: 0,
            padding: '16px 12px 12px',
          },

          '@media print': {
            display: 'none',
          },
        }}
        onClose={() => setDrawerOpen(false)}
      >
        <IconButton
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            zIndex: 1,
          }}
          onClick={() => setDrawerOpen(false)}
        >
          <CloseIcon sx={{ color: slate[500], fontSize: '28px' }} />
        </IconButton>
        <Navigation onNavigate={() => setDrawerOpen(false)} />
      </Drawer>
    </>
  );
}
